/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
export * from "./fade-slide";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/utils/animations/fade-slide/index.js
// module id = 307
// module chunks = 4